<script lang="ts">
    import { onMount } from "svelte";
    import DBG from "../code/DBG";

    function closeButtonClick() {
        var messageObject = { messageType: "dialogClosed" };
        var jsonMessage = JSON.stringify(messageObject);
        Office.context.ui.messageParent(jsonMessage);
        console.log("closeButtonClick");
    }

    onMount(() => {
        DBG.log("AuthDone - auth done, closing");
        Office.onReady((info) => {
            DBG.log("AuthDone - office onReady", info);
        });

    });
</script>

<div>AUTH DONE

    <button type="button" class="btn btn-primary" on:click="{closeButtonClick}">Close</button>
</div>
